import { useTheme } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { BREAKPOINT_XL, BREAKPOINT_LG, BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_XS } from '../common/constant.js';

var useBreakpoints = function useBreakpoints() {
  var theme = useTheme();
  var extraSmallScreen = useMediaQuery(theme.breakpoints.up("xs"), {
    noSsr: true
  });
  var smallScreen = useMediaQuery(theme.breakpoints.up("sm"), {
    noSsr: true
  });
  var mediumScreen = useMediaQuery(theme.breakpoints.up("md"), {
    noSsr: true
  });
  var largeScreen = useMediaQuery(theme.breakpoints.up("lg"), {
    noSsr: true
  });
  var extraLargeScreen = useMediaQuery(theme.breakpoints.up("xl"), {
    noSsr: true
  });
  var isExtraSmallScreen = function isExtraSmallScreen() {
    return extraSmallScreen && !smallScreen && !mediumScreen && !largeScreen && !extraLargeScreen;
  };
  var isSmallScreen = function isSmallScreen() {
    return smallScreen && !mediumScreen && !largeScreen && !extraLargeScreen;
  };
  var isMediumScreen = function isMediumScreen() {
    return mediumScreen && !largeScreen && !extraLargeScreen;
  };
  var isLargeScreen = function isLargeScreen() {
    return largeScreen && !extraLargeScreen;
  };
  var isExtraLargeScreen = function isExtraLargeScreen() {
    return extraLargeScreen;
  };
  var getBreakpoint = function getBreakpoint() {
    var result;
    if (isExtraLargeScreen()) {
      result = BREAKPOINT_XL;
    } else if (isLargeScreen()) {
      result = BREAKPOINT_LG;
    } else if (isMediumScreen()) {
      result = BREAKPOINT_MD;
    } else if (isSmallScreen()) {
      result = BREAKPOINT_SM;
    } else {
      result = BREAKPOINT_XS;
    }
    return result;
  };
  return {
    isExtraSmallScreen: isExtraSmallScreen,
    isSmallScreen: isSmallScreen,
    isMediumScreen: isMediumScreen,
    isLargeScreen: isLargeScreen,
    isExtraLargeScreen: isExtraLargeScreen,
    getBreakpoint: getBreakpoint
  };
};

export { useBreakpoints };
//# sourceMappingURL=useBreakpoints.js.map
